export default __webpack_public_path__ + "static/media/organization.f2da7885.svg";